import { useStaticQuery, graphql } from "gatsby";

const useLayoutQuery = () => {
  return useStaticQuery(graphql`
    fragment ProjectCard on SanityProjects {
      id
      title
      orderRank
      projectColourSwatch {
        value
      }
      slug {
        current
      }
      mainImage {
        asset {
          gatsbyImageData(
            layout: CONSTRAINED,
            formats: [AUTO, WEBP],
            placeholder: DOMINANT_COLOR
          )
        }
      }
      ## date(formatString: "ddd DD MMMM"
    }
    fragment SisterJournalCard on SanitySisterJournal {
      id
      title
      orderRank
      projectColourSwatch {
        value
      }
      slug {
        current
      }
      mainImage {
        asset {
          gatsbyImageData(
            layout: CONSTRAINED,
            formats: [AUTO, WEBP],
            placeholder: DOMINANT_COLOR
          )
        }
      }
      category {
        _type
        title
        slug {
          current
        }
      }
      ## date(formatString: "ddd DD MMMM"
    }
    query SiteAndArtistsQuery {
      site {
        siteMetadata {
          title
        }
      }
     ## allSanityArtist {
      ##    nodes {
        ##      name
        ##     discipline
        ##      slug {
          ##        current
          ##      }
          ##        portraitImage {
    ##         asset {
      ##           url
              ##             publicUrl
              ##          }
              ##        }
              ##       landscapeImage {
                ##         asset {
                  ##          url
              ##            publicUrl
              ##         }
              ##        }
              ##     }
              ##     }
    }
  `);
};

export default useLayoutQuery;